import { render, staticRenderFns } from "./PaymentsPerWeekChart.vue?vue&type=template&id=28d657a1"
import script from "./PaymentsPerWeekChart.vue?vue&type=script&lang=js"
export * from "./PaymentsPerWeekChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports